import './ProfileTipsCard.css';
import { useState, useMemo } from 'react';
import { Button, Card, CardContent, IconButton, Skeleton, Typography } from '@mui/material';
import { TbRefresh } from 'react-icons/tb';
import { useAuth } from 'context/AuthContext';
import { useProfile } from 'context/ProfileContext';
import { useTranslation } from 'react-i18next';
import { getRelevantTips, getTipsForPlan } from './tips';
import { useDashboard } from 'context/DashboardContext';

const ProfileTipsCard = () => {
    const { t } = useTranslation();
    const { setView } = useDashboard();
    const { state, loading } = useProfile();
    const { user } = useAuth();
    const [tipIndex, setTipIndex] = useState(0);

    const plan = user?.plan ?? 'basic';

    const relevantTips = useMemo(() => {
        const allTips = getTipsForPlan(plan);
        return getRelevantTips(allTips, state, user);
    }, [state, user, plan]);

    const currentTip = relevantTips.length > 0
        ? relevantTips[tipIndex % relevantTips.length]
        : null;

    const handleNext = () => {
        setTipIndex(prev => (prev + 1) % relevantTips.length);
    };

    if (!loading && relevantTips.length === 0) return null;

    return (
        <Card variant="outlined" className='dashboard-card grow'>
            <CardContent className='tips-card-content'>
                <div className='tips-header'>
                    <Typography variant="body1" component="p" className='tips-title'>
                        {t('dashboard.main.tips.cardTitle')}
                    </Typography>
                    {!loading && relevantTips.length > 1 && (
                        <IconButton
                            size="small"
                            onClick={handleNext}
                            className='tips-refresh-btn'
                            aria-label="Next tip"
                        >
                            <TbRefresh size={18} />
                        </IconButton>
                    )}
                </div>

                <div className='tips-body'>
                    {loading ? (
                        <>
                            <Skeleton variant="text" width="60%" height={22} />
                            <Skeleton variant="text" width="90%" height={18} />
                            <Skeleton variant="text" width="75%" height={18} />
                        </>
                    ) : currentTip ? (
                        <>
                            <Typography variant="body2" className='tips-tip-title'>
                                {t(currentTip.titleKey)}
                            </Typography>
                            <Typography variant="body2" className='tips-tip-body'>
                                {t(currentTip.bodyKey)}
                            </Typography>
                        </>
                    ) : null}
                </div>

                <div className='tips-footer'>
                    <Button
                        variant="outlined"
                        size="large"
                        disabled={loading}
                        onClick={() => setView(currentTip.ctaView)}
                        className='tips-cta-btn'
                    >
                        {loading
                            ? <div className='btn-text-container'><Skeleton width={100} height={16} /></div>
                            : currentTip ? t(currentTip.ctaKey) : null
                        }
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};

export default ProfileTipsCard;
